import { Edit } from "react-admin";
import * as React from "react";
import { TranslationsCreateForm } from "./TranslationsCreate";

export const TranslationsEdit = () => (
  <Edit>
    <TranslationsCreateForm />
  </Edit>
);
